var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAngleDoubleDown(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.676,
    height: 15.633,
    viewBox: "0 0 15.676 15.633",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_131",
    "data-name": "Group 131",
    transform: "translate(1190.833 518.311) rotate(180)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "arrow-ios-back-fill",
    transform: "translate(1190.833 502.678) rotate(90)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35",
    "data-name": "Path 35",
    d: "M6.536,15.676a1.12,1.12,0,0,1-.873-.414L.255,8.544a1.12,1.12,0,0,1,0-1.422L5.853.4A1.121,1.121,0,1,1,7.577,1.838l-5,6,4.837,6a1.12,1.12,0,0,1-.873,1.836Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "arrow-ios-back-fill-2",
    "data-name": "arrow-ios-back-fill",
    transform: "translate(1190.833 510.475) rotate(90)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35-2",
    "data-name": "Path 35",
    d: "M6.536,15.676a1.12,1.12,0,0,1-.873-.414L.255,8.544a1.12,1.12,0,0,1,0-1.422L5.853.4A1.121,1.121,0,1,1,7.577,1.838l-5,6,4.837,6a1.12,1.12,0,0,1-.873,1.836Z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAngleDoubleDown);
export default __webpack_public_path__ + "static/media/angle-double-down.44fc92921a7a838a3bda0e83533675c2.svg";
export { ForwardRef as ReactComponent };